module.exports = __webpack_public_path__ + "img/carreteras-edificacion.bb58902d.webp";